import React from 'react';

const CloudIcon = ({ color="#56B0BB", size = "48" }: { size?: string | number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_77_12024)">
        <path
          d="M13.4711 30.8658C11.1989 29.351 9.20075 27.141 8.26302 25.299C7.32528 23.4571 6.85817 21.4116 6.90339 19.3452C6.9486 17.2787 7.50474 15.2556 8.52214 13.4565C9.53955 11.6573 10.9866 10.138 12.7341 9.03431C14.4815 7.93058 16.4751 7.27672 18.5368 7.13109C20.5985 6.98546 22.6642 7.35259 24.5494 8.19972C26.4347 9.04684 28.0809 10.3476 29.3411 11.9859C30.6013 13.6242 31.4363 15.549 31.7715 17.5886C32.0375 17.5697 32.2845 17.5506 32.5505 17.5506C34.5671 17.5499 36.5191 18.2623 38.0612 19.5619C39.6033 20.8615 40.6362 22.6645 40.9773 24.6522C41.3185 26.6399 40.9773 28.9511 39.9252 30.4237C39.196 31.4443 38.3964 32.6516 36.7046 33.4816M29.7047 33.3892L24.0047 27.6889L18.3047 33.3892M23.9958 27.6889V40.8889"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_77_12024">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CloudIcon;
